import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";

const LOGO_URL = "/elysian-logo.png";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (r.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      toast.error(r.error || "Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="Elysian Cars" className="h-12 w-auto object-contain" />
        </div>
        <div className="border border-white/5 bg-[#0F0F0F] p-8 md:p-10">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={14} className="text-[#C6A15B]" />
            <div className="section-label">Admin Access</div>
          </div>
          <h1 className="font-display text-3xl font-light mb-8">Sign in</h1>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="ec-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="ec-input"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="ec-label" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="ec-input"
                data-testid="login-password"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="btn-gold w-full justify-center disabled:opacity-60"
              data-testid="login-submit"
            >
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
